import { CREATE_NOTIFICATION, REMOVE_NOTIFICATION } from '../constants/notifications';

export const initialState = {
  generic: []
};

export const notificationsReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case CREATE_NOTIFICATION:
      return {
        ...state,
        generic: [...state.generic, payload]
      };
      case REMOVE_NOTIFICATION:
      return {
        ...state,
        generic: state.generic.filter((notification) => notification.id !== payload.id),
      };
    default:
      return state;
  }
};
